import firestore from "./firebase";
import { addDoc, collection, setDoc, doc, getDocs } from "firebase/firestore"; 

const createAccount = async(data) => {    

    const users = await getDocs(collection(firestore, "users"));
    const users_id = [];
    
    users.forEach((doc) => {            
        users_id.push(parseInt(doc.data().id));
    });

    users_id.sort();

    const user_id = parseInt(users_id[users_id.length - 1]) + 1;

    const newUser = {
        id: user_id,        
        ...data
    }

    const checkpoints = {
        checkpoint_1: 0,
        checkpoint_2: 0,
        checkpoint_3: 0,
        checkpoint_4: 0,
        checkpoint_5: 0,
        checkpoint_6: 0,
    };

    const user =  await addDoc(collection(firestore, "users"), newUser);
    
    await setDoc(doc(firestore, "checkpoints", user.id), {
        easy: checkpoints,
        medium: checkpoints,
        hard: checkpoints,
    });

    return { new_user: user.id, user_id };
}

export default createAccount;